if (!window.Eurus.loadedScript.has('grouped-options.js')) {
  window.Eurus.loadedScript.add('grouped-options.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xGroupedOptions', (sectionId) => ({
        // FB-1366: resolve the flyout DOM scope. The injected flyout markup does not
        // include the #choose-options-content wrapper, so scope to the nearest injected
        // container (desktop: .choose-options; mobile: #choose-options-mobile) and fall
        // back to document only as a last resort.
        getRoot(el) {
          return (
            el.closest('.choose-options') ||
            el.closest('#choose-options-mobile') ||
            document
          );
        },

        // FB-1366: set every button-text span (button-label renders two for its hover
        // effect); guard buttons with no text node (the mobile icon-only button).
        setButtonText(button, value) {
          const texts = button.querySelectorAll('.button-text');
          texts.forEach((t) => (t.textContent = value));
        },

        // FB-1366: apply the selected size's availability to the flyout CTA.
        //  - available            -> Add to cart (enabled)
        //  - out of stock + waitlist -> hide ATC, show Join Waitlist (opens Klaviyo)
        //  - out of stock, no waitlist -> ATC disabled, "Out of stock"
        applyAvailability(root, isAvailable, isWaitlist, waitlistFormId) {
          const addToCartButtons = root.querySelectorAll(
            `[id='x-atc-button-${sectionId}']`,
          );
          const waitlistBtn = root.querySelector(
            `[id='grouped-waitlist-${sectionId}']`,
          );

          if (isAvailable) {
            addToCartButtons.forEach((button) => {
              button.style.display = '';
              button.removeAttribute('disabled');
              this.setButtonText(button, window.Eurus.atc);
            });
            if (waitlistBtn) {
              waitlistBtn.classList.add('hidden');
              waitlistBtn.onclick = null;
            }
            return;
          }

          if (isWaitlist && waitlistFormId) {
            addToCartButtons.forEach((button) => {
              button.style.display = 'none';
            });
            if (waitlistBtn) {
              waitlistBtn.classList.remove('hidden');
              waitlistBtn.onclick = (e) => {
                e.preventDefault();
                window._klOnsite = window._klOnsite || [];
                window._klOnsite.push(['openForm', waitlistFormId]);
              };
            }
            return;
          }

          // Out of stock, not a waitlist product.
          addToCartButtons.forEach((button) => {
            button.style.display = '';
            button.setAttribute('disabled', 'disabled');
            this.setButtonText(button, window.Eurus.oos);
          });
          if (waitlistBtn) {
            waitlistBtn.classList.add('hidden');
            waitlistBtn.onclick = null;
          }
        },

        // FB-1366: sync all flyout state (variant id, price, payment terms, detail link
        // and CTA) to a size radio. Shared by change events and initial render so the
        // default in-stock selection is reflected even if the flyout loaded for another
        // sibling.
        syncFromRadio(el) {
          const variantId = el.dataset.variantId || el.value;
          const productId = el.dataset.productId;
          const productUrl = el.dataset.productUrl;
          const isAvailable = el.dataset.available === 'true';
          const isWaitlist = el.dataset.isWaitlist === 'true';
          const waitlistFormId = el.dataset.waitlistFormId;
          const root = this.getRoot(el);

          const variantInputs = root.querySelectorAll(
            `[id='update-variant-${sectionId}']`,
          );
          const productInputs = root.querySelectorAll(
            "input[name='product-id']",
          );
          const installmentInputs = root.querySelectorAll(
            `#product-form-installment-${sectionId} input[name='id']`,
          );
          const priceMap = root.querySelector(
            `#grouped-price-map-${sectionId}`,
          );
          const priceDestination = root.querySelector(`#price-${sectionId}`);
          const viewDetailLink = root.querySelector('a.view_product_detail');

          // Update hidden variant id
          variantInputs.forEach((input) => (input.value = variantId));

          // Update hidden product id
          productInputs.forEach((input) => (input.value = productId));

          // Swap price HTML
          if (priceMap && priceDestination && priceMap.content) {
            const node = priceMap.content.querySelector(
              `[data-vid='${variantId}']`,
            );
            if (node) {
              priceDestination.innerHTML = node.innerHTML;
            }
          }

          // Sync payment terms
          installmentInputs.forEach((input) => (input.value = variantId));

          // Toggle CTA (Add to cart / Join Waitlist / Out of stock)
          this.applyAvailability(root, isAvailable, isWaitlist, waitlistFormId);

          // Update "view full details" link
          if (viewDetailLink && productUrl) {
            viewDetailLink.setAttribute('href', productUrl);
          }
        },

        onGroupVariantChange(el) {
          this.syncFromRadio(el);
        },

        init() {
          const checkedInput = this.$el.querySelector(
            'input[name^=grouped-size]:checked',
          );
          if (checkedInput) {
            this.syncFromRadio(checkedInput);
          }
        },
      }));
    });
  });
}
